// Path: apps/blend-food/src/app/app.module.ts
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';

import { ShellModule } from '@cardapio-online/shell';
import { APP_CONFIG } from '@cardapio-online/config';
import { HttpCoreModule } from '@cardapio-online/http';
import { appConfigFactory } from './factories/app-config.factory';
import { TenantResolverService } from '@cardapio-online/tenant';
import { BrandKernelService } from '@cardapio-online/theme';

export function brandKernelInitializer(brandKernel: BrandKernelService) {
  return () => brandKernel.bootstrap();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    ShellModule,
    HttpCoreModule.forRoot(),
    RouterModule.forRoot(appRoutes),
  ],
  providers: [
    {
      provide: APP_CONFIG,
      useFactory: appConfigFactory,
      deps: [TenantResolverService],
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [BrandKernelService],
      useFactory: brandKernelInitializer,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}